import React, { Component } from "react";
import { withRouter } from "react-router-dom";
import { withStyles } from "@material-ui/core/styles";
import { connect } from "react-redux";
import Axios from "axios";
import TextField from "@material-ui/core/TextField";
import Button from "@material-ui/core/Button";
import LinearProgress from "@material-ui/core/LinearProgress";
import Paper from "@material-ui/core/Paper";
import Divider from "@material-ui/core/Divider";

import NavBar from "../../../../Component/NavBar/AdminHeader/AdminHeader";
import { url } from "../../../../config/config";
import { useStyles } from "./AddBookCategory.css";
import AdminPageTitle from "../../../../Component/AdminPageTitle/AdminPageTitle";
import FormLoader from "../../../../Component/FormLoader/FormLoader";

const CustomLinearProgress = withStyles((theme) => ({
  root: {
    height: 10,
    borderRadius: 5,
  },
  colorPrimary: {
    backgroundColor:
      theme.palette.grey[theme.palette.type === "light" ? 200 : 700],
  },
  bar: {
    borderRadius: 5,
    backgroundColor: "#1a90ff",
  },
}))(LinearProgress);

class AddBookCategory extends Component {
  constructor(props) {
    super(props);
    this.state = {
      data: {
        categoryName: "",
        categoryImageUrl: "",
      },
      categoryNameError: "",
      categoryImageError: "",
      imagePercentage: 0,
      success: "",
      loading: false,
    };
  }

  componentDidMount() {
    if (this.props.editStatus) {
      this.getData(this.props.categoryId);
    }
  }

  getData = async (categoryId) => {
    const response = await Axios.get(`${url}/api/categories/${categoryId}`, {
      headers: {
        "x-auth-token": this.props.adminToken,
      },
    });
    if (response.data.length !== 0) {
      this.setState({
        data: {
          categoryName: response.data.name,
          categoryImageUrl: response.data.imageUrl,
        },
      });
    }
  };

  handleImageUpload = (e) => {
    let reader = new FileReader();
    let files = e.target.files[0];
    reader.onload = (e) => {
      this.setState({
        data: {
          ...this.state.data,
          categoryImageUrl: e.target.result,
        },
      });
    };

    reader.onprogress = (data) => {
      if (data.lengthComputable) {
        var progress = parseInt((data.loaded / data.total) * 100, 10);
        this.setState({
          imagePercentage: progress,
        });
      }
    };

    if (files) {
      reader.readAsDataURL(files);
    }
  };

  handleImageProgress = () =>
    this.state.imagePercentage ? (
      <React.Fragment>
        <CustomLinearProgress
          value={this.state.imagePercentage}
          variant="determinate"
        />
        {this.state.imagePercentage === 100 ? (
          <React.Fragment>Upload Complete</React.Fragment>
        ) : (
          <React.Fragment>{this.state.imagePercentage}%</React.Fragment>
        )}
      </React.Fragment>
    ) : null;

  checkError = (CategoryNameError) => {
    let categoryNameError = CategoryNameError ? CategoryNameError : "";
    let categoryImageError = "";

    if (this.state.data.categoryName.length < 3) {
      categoryNameError =
        "The name of category must be more than 3 characters.";
    }

    if (!this.state.data.categoryImageUrl) {
      categoryImageError = "Image must be uploaded.";
    }

    if (categoryNameError || categoryImageError) {
      this.setState({
        categoryNameError,
        categoryImageError,
      });
      return true;
    } else {
      this.setState({
        categoryNameError: "",
        categoryImageError: "",
      });
      return false;
    }
  };

  handleSubmit = async (e) => {
    e.preventDefault();
    let errorStatus = this.checkError();
    if (errorStatus === false) {
      this.setState({ loading: true });
      if (this.props.editStatus) {
        const response = await Axios.put(
          `${url}/api/categories/${this.props.categoryId}`,
          this.state.data,
          {
            headers: {
              "x-auth-token": this.props.adminToken,
            },
          }
        );
        if (response.data) {
          if (response.data.success) {
            this.setState({
              success: response.data.success,
            });
            this.props.history.push("/_administration_/category/view");
          }
          if (response.data.message) {
            this.setState({ loading: false });
            this.checkError(response.data.message);
          }
        }
      } else {
        const response = await Axios.post(
          `${url}/api/categories`,
          this.state.data,
          {
            headers: {
              "x-auth-token": this.props.adminToken,
            },
          }
        );
        if (response.data) {
          if (response.data.success) {
            this.setState({
              success: response.data.success,
              error: false,
            });
            this.props.history.push("/_administration_/category/view");
          }
          if (response.data.message) {
            this.setState({ loading: false });
            this.checkError(response.data.message);
          }
        }
      }
    }
  };

  render() {
    const { classes } = this.props;
    return (
      <div>
        <NavBar />
        <div className={classes.root}>
          <AdminPageTitle title="Add Book Category" />
          <Divider />
          <form onSubmit={this.handleSubmit}>
            <TextField
              name="categoryName"
              type="text"
              label="Category Name"
              fullWidth
              required
              margin="normal"
              variant="outlined"
              error={this.state.categoryNameError ? true : false}
              helperText={this.state.categoryNameError}
              InputProps={{
                classes: {
                  notchedOutline: classes.notchedOutline,
                  focused: classes.focused,
                },
              }}
              InputLabelProps={{
                classes: {
                  root: classes.labelRoot,
                  focused: classes.labelFocused,
                },
                shrink: true,
              }}
              value={this.state.data.categoryName}
              onChange={(e) =>
                this.setState({
                  data: { ...this.state.data, categoryName: e.target.value },
                })
              }
            />

            <div
              style={{
                display: "flex",
                flexDirection: "column",
                paddingTop: 10,
                fontWeight: "bold",
                borderRadius: `10 solid black`,
              }}
            >
              <label style={{ fontSize: 18 }}>
                Choose background image for book category
              </label>
              <input
                type="file"
                accept="image/*"
                onChange={this.handleImageUpload}
              />
              <div style={{ padding: 10 }}>{this.handleImageProgress()}</div>
              <div style={{ color: "red" }}>
                {this.state.categoryImageError}
              </div>
            </div>

            {this.state.data.categoryName && this.state.data.categoryImageUrl && (
              <div style={{ padding: 40 }}>
                <div style={{ fontSize: 20 }}>Preview</div>
                <Paper
                  className={classes.paper}
                  style={{
                    backgroundImage: `url(${this.state.data.categoryImageUrl})`,
                  }}
                >
                  <div
                    style={{
                      color: "#ffffff",
                      fontSize: 40,
                      fontWeight: "bolder",
                    }}
                  >
                    {this.state.data.categoryName}
                  </div>
                </Paper>
              </div>
            )}

            <div style={{ display: "flex", alignItems: "center" }}>
              <Button
                type="submit"
                variant="outlined"
                className={classes.buttonStyle}
              >
                {this.props.editStatus ? "Update" : "Submit"}
              </Button>
              {this.state.loading && <FormLoader />}
            </div>
          </form>
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    adminToken: state.AdminReducer.adminToken,
  };
};

export default connect(
  mapStateToProps,
  null
)(withStyles(useStyles)(withRouter(AddBookCategory)));
